import * as React from "react";
import { Activity, ShieldCheck, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const pillars = [{
  title: "Measure",
  description: "We Measure metabolic markers, body composition, and aging indicators.",
  icon: Activity
}, {
  title: "Optimize",
  description: "Optimize with advanced therapies focused on fat loss, cellular health, recovery, and longevity.",
  icon: Zap
}, {
  title: "Maintain",
  description: "Maintained through performance-driven wellness strategies.",
  icon: ShieldCheck
}];
export default function PPerformanceLongevity() {
  return <section id="p-performance-longevity" className="relative w-full bg-background py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-10 z-0" aria-hidden="true">
        <span className="font-serif text-[60vw] md:text-[40vw] leading-none text-foreground">
          P
        </span>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        {}
        <div className="max-w-3xl mx-auto text-center mb-20">
          <span className="block text-sm md:text-base font-semibold tracking-widest uppercase text-muted-foreground mb-6">
            Formerly Anti-Aging + Weight Loss
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-tight">
            Enhance how you look, feel, and function.
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16 max-w-6xl mx-auto mb-20">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="size-16 rounded-2xl bg-secondary/50 flex items-center justify-center mb-8 text-foreground transition-colors duration-300 group-hover:bg-secondary">
                  <Icon className="size-8" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-default font-semibold text-foreground mb-4">
                  {pillar.title}
                </h3>
                <p className="text-muted-foreground text-lg leading-relaxed">
                  {pillar.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div className="flex justify-center">
          <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-[#8FA88F] hover:text-primary-foreground px-10 py-7 text-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl">
            <Link to="/ProtocolsPage">Explore Protocols</Link>
          </Button>
        </div>
      </div>
    </section>;
}